import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const TagIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M16.354 7.65238L16.3476 7.65235M19.5226 2.85129L13.7222 2.40511C13.2079 2.36555 12.7021 2.55269 12.3374 2.91739L2.91751 12.3373C2.22753 13.0272 2.22753 14.1459 2.9175 14.8359L9.16405 21.0824C9.85402 21.7724 10.9727 21.7724 11.6627 21.0824L21.0825 11.6626C21.4472 11.2978 21.6344 10.792 21.5948 10.2777L21.1486 4.47737C21.0818 3.6085 20.3914 2.91813 19.5226 2.85129Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

TagIcon.displayName = 'TagIcon';
